import SSComments from "./comments"
import SSContactsFollow from "./contacts"
import SSCommentsLoggedIn from "./comments_loggedin"

import SSSuperUserActions from './su'
(function(){
  var stats_initialized = false;

  function setupStats() {
    if(stats_initialized) {
      return;
    }
    stats_initialized = true;
    var url_params = { id: slideshare_object.slideshow.id };
    if (slideshare_object.analytics_api_enabled) {
      $.ajax({
        type: 'GET',
        url: '/slideshow/stats',
        data: url_params,
        dataType: "json",
        success: function (data) {
          var $embeds = $('.j-info-embeds');
          var $embedsContainer = $embeds.find('.j-embeds-container');
          $('.j-slideshare-views').text(data.slideshow_analytics_on_ss);
          $('.j-embed-views').text(data.slideshow_analytics_views_from_embeds);
          if (data.slideshow_analytics_top_embeds.length > 0) {
            for (var i = 0; i < data.slideshow_analytics_top_embeds.length; i++) {
              var emb = data.slideshow_analytics_top_embeds[i];
              $embedsContainer.append('<div class="small-8 columns stat-label">' + emb.url +
                '</div><div class="small-4 columns stat-value text-right">' + emb.hits + '</div>');
            }

            $embeds.find('.j-no-embeds').remove();
            $embedsContainer.show();
          }
        }
      });
    }
  }

  slideshare_object.svComments = $('.commentsNotes');
  slideshare_object.svCommentsForm = $('form.j-comment-post');
  slideshare_object.svCommentsul = $('#commentsList');
  slideshare_object.svTools = $('.j-tools');
  slideshare_object.setup_instruments_interaction();

  $('.j-post-comment').click(function(e) {
    e.preventDefault();
    $.scrollTo($(this).attr('href'), 500, {offset: -50});
    $('.j-post-comment-textarea').focus();
  });

  $('#slideshow-views-modal-trigger').on('click', function() {
    setupStats();
  });

  // TODO: should be part of the player...
  $('.j-action-share').unbind('click').on('click', function() {
    window.slideviewInteraction.hideAll('msharing');
    if($.slideshareEventManager) {
      $.slideshareEventManager.trigger('playershare', 'toolbar_');
    }
  });

  $('.j-download').on('click', function() {
    if($('.player').hasClass('fullscreen')) {
      $.slideshareEventManager && $.slideshareEventManager.trigger('leavefullscreen');
    }
  });

  // Fix Foundation Tab component keyboard focus trapping
  $(document)
    .off('keydown.fndtn.tab')
    // Prevent arrow key tab navigation from activating next/previous slide
    .on('keyup', '[data-tab]', function(evt) {
      var key = evt.which;
      if (key === 37 || key === 39) {
        evt.stopPropagation();
        // Fix Safari keyboard carat browse on tabs
        evt.preventDefault();
      }
    });
  
  var ssComments = new SSComments(slideshare_object);
  var ssContactsFollow = new SSContactsFollow(slideshare_object);
  var ssSuperUser = null;

  if(slideshare_object.user.loggedin) {
     ssComments = new SSCommentsLoggedIn(slideshare_object);
     ssSuperUser = new SSSuperUserActions(slideshare_object);
  }

  slideshare_object.setup_flagging_interaction();

  slideshare_object.clippingTracker = new slideshare_object.ClippingTracker({
    userIsOwner: slideshare_object.user && slideshare_object.user.loggedin
  });

  slideshare_object.ready();

  window.slideviewInteraction = new slideshare_object.slideviewInteraction();
})();
